__webpack_require__.p = "/modules/custom/kurt_configurator/frontend/build/";